import { useQueryClient } from "@tanstack/react-query";
import { $api } from "../generated/client";

const CONFIGURATION_PATH = "/super-admin/shops/{shopId}/configuration";

const configurationOptions = (shopId: string) =>
  $api.queryOptions("get", CONFIGURATION_PATH, {
    params: { path: { shopId } },
  });

/** The shop's configuration as Care edits it in the super admin (BBS-406). */
export function useSuperAdminShopConfiguration(shopId: string) {
  return $api.useQuery("get", CONFIGURATION_PATH, {
    params: { path: { shopId } },
  });
}

/**
 * Edits the shop's plan, field by field (`null` = cleared, or back to the
 * default). The answer is the new configuration: written to the cache as is.
 */
export function useUpdateSuperAdminShopPlan(shopId: string) {
  const queryClient = useQueryClient();

  return $api.useMutation(
    "patch",
    "/super-admin/shops/{shopId}/configuration/plan",
    {
      onSuccess: (configuration) => {
        queryClient.setQueryData(
          configurationOptions(shopId).queryKey,
          configuration,
        );
        // The overview list shows the plan code and `planProductRecommendation`.
        void queryClient.invalidateQueries({
          queryKey: ["get", "/super-admin/shops"],
        });
      },
    },
  );
}

/**
 * Edits the options only Baback sets (`BABACK_OPTIONS` in baback-end), field
 * by field. The answer is the new configuration: written to the cache as is.
 */
export function useUpdateSuperAdminShopBabackOptions(shopId: string) {
  const queryClient = useQueryClient();

  return $api.useMutation(
    "patch",
    "/super-admin/shops/{shopId}/configuration/options",
    {
      onSuccess: (configuration) => {
        queryClient.setQueryData(
          configurationOptions(shopId).queryKey,
          configuration,
        );
      },
    },
  );
}
